import { ApiError } from "./apiClient";
import { he, messageForFrom } from "../i18n/he";

// Map a thrown API error to a user-facing Hebrew message. Admin (and other) views must never
// surface the raw "API error" default or an English Error.toString() to the user.
//
//   401 -> session expired / open with an admin account
//   403 -> admin permission required (NOT a silent data exposure — the server correctly
//          refused; we explain it in Hebrew)
//   server problem-details with a known VC-* code -> its catalogued Hebrew message
//   anything else -> generic Hebrew system error
export function apiErrorToHebrew(error: unknown): string {
  return apiErrorToMessage(error, he);
}

export function apiErrorToMessage(
  error: unknown,
  strings: { admin: { sessionExpired: string; notAuthorized: string }; errors: Record<string, string> }
): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return strings.admin.sessionExpired;
    if (error.status === 403) return strings.admin.notAuthorized;

    // Some endpoints return RFC-9457 problem-details whose `type` carries a VC-* code.
    const code = error.problem.type;
    if (code && code in strings.errors) return messageForFrom(strings, code);

    // A meaningful server-provided title/detail can be shown as-is, but the bare "API error"
    // fallback (empty body) must be replaced with the generic Hebrew system message.
    const provided = error.problem.title || error.problem.detail;
    if (provided && provided !== "API error") return provided;

    return messageForFrom(strings, "VC-SYS-001");
  }
  return messageForFrom(strings, "VC-SYS-001");
}
